<template>
  <v-container>
    <v-layout class="row wrap">
      <v-flex xs6 pr-2>
        <h2>Moedas das contas bancárias internas*</h2>
        <v-layout class="col wrap justify-start">
          <v-flex xs2>
            <v-checkbox
              v-model="partner.internal_bank_account_currencies"
              label="BRL"
              value="BRL"
            ></v-checkbox>
          </v-flex>
          <v-flex xs2>
            <v-checkbox
              v-model="partner.internal_bank_account_currencies"
              label="MXN"
              value="MXN"
            ></v-checkbox>
          </v-flex>
          <v-flex xs2>
            <v-checkbox
              v-model="partner.internal_bank_account_currencies"
              label="COP"
              value="COP"
            ></v-checkbox>
          </v-flex>
          <v-flex xs2>
            <v-checkbox
              v-model="partner.internal_bank_account_currencies"
              label="CLP"
              value="CLP"
            ></v-checkbox>
          </v-flex>
          <v-flex xs2>
            <v-checkbox
              v-model="partner.internal_bank_account_currencies"
              label="USD"
              value="USD"
            ></v-checkbox>
          </v-flex>
          <v-flex xs2>
            <v-checkbox
              v-model="partner.internal_bank_account_currencies"
              label="EUR"
              value="EUR"
            ></v-checkbox>
          </v-flex>
          <v-flex xs2>
            <v-checkbox
              v-model="partner.internal_bank_account_currencies"
              label="USDT"
              value="USDT"
            ></v-checkbox>
          </v-flex>
          <v-flex xs2>
            <v-checkbox
              v-model="partner.internal_bank_account_currencies"
              label="USDC"
              value="USDC"
            ></v-checkbox>
          </v-flex>
          <v-flex xs2>
            <v-checkbox
              v-model="partner.internal_bank_account_currencies"
              label="USDG"
              value="USDG"
            ></v-checkbox>
          </v-flex>
          <v-flex xs2>
            <v-checkbox
              v-model="partner.internal_bank_account_currencies"
              label="RLUSD"
              value="RLUSD"
            ></v-checkbox>
          </v-flex>
        </v-layout>
      </v-flex>
      <v-flex xs6 pr-2>
        <h2>Separação de fluxos de contas bancárias internas</h2>
        <v-radio-group v-model="partner.separate_internal_bank_account_flows">
          <div class="display-flex-baseline">
            <v-radio label="true" value="true"></v-radio>
            <v-radio label="false" value="false"></v-radio>
          </div>
        </v-radio-group>
      </v-flex>
    </v-layout>
    <h2 slot="label">Company</h2>
    <v-layout class="row wrap">
      <v-flex xs6 pr-2>
        <v-text-field
          box
          v-model="company.social_name"
          background-color="white"
          label="Nome da empresa*"
          :rules="lengthValidation"
          :errorMessages="errorMessagesFor('social_name')"
        ></v-text-field>
      </v-flex>
      <v-flex xs6>
        <v-text-field
          box
          v-model="company.company_name"
          background-color="white"
          label="Nome fantasia"
        ></v-text-field>
      </v-flex>
      <v-flex xs5>
            <CountrySelect :model="company.fiscal_country" label="País*" @onSelectedCountry="this.selectedCountry" />
      </v-flex>
      <v-flex xs2>  
          <v-select
          label="Tipo do documento"
          v-model="company.document_type"
          class="white-select mr-2"
          :items="getCompanyDocumentTypes"
        ></v-select>
      </v-flex>
      <v-flex xs5>
        <v-text-field
          box
          v-model="company.document_number"
          background-color="white"
          :errorMessages="errorMessagesFor('document_number')"
          :rules="lengthValidation"
          label="Número do documento*"
          :mask="documentNumberMask()"
        ></v-text-field>
      </v-flex>
    </v-layout>
    <h2 slot="label">Usuário</h2>
    <v-layout class="row wrap">
      <v-flex xs6 pr-2>
        <v-text-field
          box
          v-model="user.name"
          background-color="white"
          label="Nome Social*"
          :rules="lengthValidation"
        ></v-text-field>
      </v-flex>
      <v-flex xs6>
        <v-text-field
          box
          v-model="user.username"
          background-color="white"
          label="Username*"
          :rules="emailValidation"
        ></v-text-field>
      </v-flex>
      <v-flex xs6>
        <v-text-field
          box
          v-model="partner.protonmail"
          background-color="white"
          label="Proton Mail*"
          :rules="emailValidation"
        ></v-text-field>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
  import CountrySelect from "./components/filters/CountrySelect"
  export default {
    name: 'AdminPartnerCreateForm',
    components: {CountrySelect},
    props: {
      partner: {
        type: Object
      },
      company: {
        type: Object
      },
      user: {
        type: Object
      }
    },
    data(vm) {
      return {
        errors: []
      }
    },
    computed: {
      lengthValidation() {
        const rules = []
        const required_rule = v => (v || '').length > 0 || 'Campo obrigatório'
        rules.push(required_rule)
        return rules
      },
      emailValidation() {
        const rules = []
        const required_rule = val => ((/[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?/g).test(val) || 'Digite um e-mail válido')
        rules.push(required_rule)
        return rules
      },
      getCompanyDocumentTypes() {
        return [
          {text: 'CNPJ', value: 'cnpj'},
          {text: 'Tax ID', value: 'tax_id'}
        ]
      }
    },
    methods: {
      errorMessagesFor(field) {
        return this.errors[field] || []
      },
      documentNumberMask() {
        switch (this.company.document_type) {
          case 'cnpj':
            return '##.###.###/####-##';
          default:
            return '';
        }
      },
      selectedCountry(selectedCountry) {
        if(selectedCountry!=null) {
          this.company.fiscal_country = selectedCountry.value
        } else {
          this.company.fiscal_country = null
        }
      }
    },
    metaInfo: {
      title: "Facilita Pay"
    },
  }
</script>

<style>
</style>




// WEBPACK FOOTER //
// src/AdminPartnerCreateForm.vue